import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { setPassword as setPasswordAction } from '../../actions/auth';

import {
    cancelToS as cancelToSAction,
    acceptToS as acceptToSAction,
    showToS as showToSAction,
} from '../../actions/tos';

import SetPasswordPage from './newSetPasswordPage';

const _mapStateToProps = ({ authentication, form }) => ({
    form,
    locale: authentication.locale,
    recaptcha2PublicKey: authentication.recaptcha2PublicKey,
    recaptcha3PublicKey: authentication.recaptcha3PublicKey,
    showCaptcha: authentication.displayCaptcha,
    fp: authentication.fp,
    socialSSOSettings: authentication.socialSSOSettings,
    authNotificationOptions: authentication.authNotificationOptions,
    disableRecaptcha3: authentication.disableRecaptcha3,
    usesNewStyles: authentication.featureFlags.launchAuthenticationRefactor,
});

const _mapDispatchToProps = {
    handleSetPassword: setPasswordAction,
    cancelToS: cancelToSAction,
    acceptToS: acceptToSAction,
    showToS: showToSAction,
};

export default withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(SetPasswordPage),
);
